
<template>
 <div>
<f-confirmation />
  <router-view/>
  
 </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import FConfirmation from "@/components/generic/FConfirmation.vue";
import * as Data from "@/../src-gen/data";
import * as ServerData from "@/../src-gen/server-data";
import * as Action from "@/../src-gen/action";
@Component({
    components: {
        FConfirmation
    }
})
export default class RootLayout extends Vue {

    mounted() {
        this.getLoggedInUser();
        this.getRoleListForUser();
    }

      getLoggedInUser() {
    const userName: any = localStorage.getItem("userName");
    Action.Login.GetUserDetails.execute1(userName, (output) => {
      this.getRoleListForUser();
    });
  }

  getRoleListForUser() {
    Action.Login.GetRoleListForUser.execute(
      new Data.Login.MyAppId(),
      (output: any) => {},
      (error) => {}
    );
  }
}
</script>

